<template> <!-- Template darf nur ein child haben -->
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Yourfrag urs App" v-bind:title="fragUrsContent"/>

    <h2>{{ title }}</h2>
    <div v-for="myVariable in fragUrsContent">{{ myVariable.welcomeText }}</div>
  </div>
</template>

<script>

import HelloWorld from '@/components/HelloWorld.vue';
import { contentfulEnvironment } from '../js/contentful';


export default {
  name: 'home',
  data() {
    return {
      title: 'my title defined in data object',
      fragUrsContent: [],
    };
  },
  components: {
    HelloWorld,
  },

  // mounted wird ausgeführt, sobald content von vue geladen
  async mounted() { // wie mounted: async function() {} -- achtung mit 
    // environmentPromise.then((environment) => environment.getEntries());
    // wait for environmentPromise
    const env = await contentfulEnvironment;
    const entries = await env.getEntries({
      content_type: 'partRoute',
    });
    console.log(entries);
    let items = entries.items.map((value, index, array) => {
      return value.fields;
    });

    this.fragUrsContent = items;
    console.log(items);

    const welcomeText = entries.items[0].fields.welcomeText;
    console.log(welcomeText);
  },
};
</script>
